export default function Django_Exercises() {
  return <div>Django_Exercises Component</div>;
}
